import { useEffect, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { Toggle } from "react-toggle-component";
import { toast } from "react-toastify";
import TextInput from "src/Components/Authentication/TextInput";

const AddMaterialModal = ({ onCancelClicked, onAddClicked, initialData }) => {
  const [name, setName] = useState(initialData?.name || "");
  const [unit, setUnit] = useState(initialData?.unit || "");
  const [isMandatory, setIsMandatory] = useState(initialData ? initialData.isMandatory : true);

  useEffect(() => {
    setName(initialData?.name || "");
    setUnit(initialData?.unit || "");
    setIsMandatory(initialData ? initialData.isMandatory : true);
  }, [initialData]);

  const handleAdd = () => {
    const trimmedName = name.trim();
    const trimmedUnit = unit.trim();
    if (!trimmedName || !trimmedUnit) {
      toast.error("Name and unit are required");
      return;
    }
    onAddClicked({ name: trimmedName, unit: trimmedUnit, isMandatory, id: initialData?.id });
  };

  const heading = initialData ? "EDIT MATERIAL" : "ADD MATERIAL";
  const actionLabel = initialData ? "SAVE" : "ADD";

  return (
    <div className="fixed left-0 top-0 flex h-screen w-screen items-center justify-center bg-black bg-opacity-30 z-30">
      <OutsideClickHandler onOutsideClick={onCancelClicked}>
        <div className="flex w-[448px] flex-col rounded-[6px] bg-white p-[18px]">
          <p className="mb-5 text-[16px] font-OpenSansMedium font-[600] text-titleColor">{heading}</p>
          <div className="flex h-full flex-col justify-between">
            <TextInput
              label="Material Name"
              placeholder="Enter material name"
              onTextChanged={setName}
              value={name}
              width="100%"
            />
            <TextInput
              label="Material Unit"
              placeholder="Enter material unit"
              onTextChanged={setUnit}
              value={unit}
              width="100%"
            />
            <p className=" text-[12px] font-OpenSansMedium font-[600] text-inputEmailTitle">Mandatory?</p>
            <Toggle
              leftBackgroundColor="#E6E7EC"
              rightBackgroundColor="#0065FD"
              borderColor="none"
              knobColor={isMandatory ? "white" : "#0065FD"}
              name="toggle-3"
              checked={isMandatory}
              onToggle={(e) => {
                setIsMandatory(e.target.checked);
              }}
            />

            <div className="flex items-center justify-between gap-4 mt-4">
              <div
                onClick={onCancelClicked}
                className="flex h-[30px] w-[50%] cursor-pointer items-center justify-center rounded-[6px] border-[1px] border-subTitleColor text-[10px] text-subTitleColor"
              >
                CANCEL
              </div>
              <div
                onClick={handleAdd}
                className="flex h-[30px] w-[50%] cursor-pointer items-center justify-center rounded-[6px] bg-blueColor text-[10px] text-white"
              >
                {actionLabel}
              </div>
            </div>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default AddMaterialModal;
